import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';

export const {
	Context: LocalPagePaginatedVictoriousPetitionsDataContext,
	Provider: LocalPagePaginatedVictoriousPetitionsDataContextProvider,
	useContext: useLocalPagePaginatedVictoriousPetitionsData,
	useAsyncData: useLocalPagePaginatedVictoriousPetitionsDataFromApi,
	prefetchAsyncData: prefetchLocalPagePaginatedVictoriousPetitionsDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'LocalPagePaginatedVictoriousPetitionsDataContext',
	dataProperty: 'victoriousPetitionsPaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug) => slug,
	hookDeps: (slug) => [slug],
	errorHandler: pageDataErrorHandler(),
});
